// Export implementations
export { STORAGE_KEYS } from "./StorageKeys";
export { StorageManager } from "./StorageManager";

// Export utilities
export { getCookie, isBrowser } from "./utils/environment";

// Define constant keys for country and locale cookies
export const COOKIE_KEYS = {
  COUNTRY: "country",
  LOCALE: "locale",
};
